import { ANIMATION_DURATION_IN_MILLIS } from "components/Message/configs";
import { useMessageContext } from "providers/MessageProvider";
import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import Success from "./Success";
import Supervision from "./Supervision";

const Prompt = React.forwardRef<HTMLDivElement>((_, ref) => {
  const { isFormSuccessVisible } = useMessageContext();
  const [displaySuccess, setDisplaySuccess] = useState(false);

  useEffect(() => {
    if (isFormSuccessVisible) {
      setDisplaySuccess(true);
      return;
    }

    setTimeout(() => {
      setDisplaySuccess(false);
    }, ANIMATION_DURATION_IN_MILLIS);
  }, [isFormSuccessVisible]);

  return (
    <Container ref={ref}>
      <Supervision />
      {displaySuccess && <Success />}
    </Container>
  );
});

export default Prompt;
